import update from 'immutability-helper';
import * as types from './types';
import { DATASET } from '@utils/constants';
import { APP_VIEWER_SESSIONS_METRIC_FIELDS, APP_VIEWER_SESSIONS_QUERY_CONFIG } from './constants';

export const query = {
  type: 'group-by',
  dataset: DATASET,
  metrics: APP_VIEWER_SESSIONS_METRIC_FIELDS, // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 1500,
  groupBy: APP_VIEWER_SESSIONS_QUERY_CONFIG['dimensions'], // dimension name
  orderBy: 'desc',
  sortBy: [], // metric name
  options: {
    withTotals: true,
  },
};

const initialState = {
  dimensions: APP_VIEWER_SESSIONS_QUERY_CONFIG['dimensions'],
  query: { queries: [query] },
  response: [],
  isFetching: false,
  errorCode: 0,
  errorMsg: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_QUERY: {
      const newQuery = state.query;
      return update(state, {
        query: { $set: newQuery },
      });
    }
    case types.FETCHING: {
      return update(state, {
        query: {
          $set: action.query,
        },
        isFetching: {
          $set: true,
        },
      });
    }
    case types.FETCHING_SUCCESS: {
      return update(state, {
        response: {
          $set: action.response,
        },
        errorCode: {
          $set: 0,
        },
        errorMsg: {
          $set: '',
        },
        isFetching: {
          $set: false,
        },
      });
    }
    case types.FETCHING_FAIL: {
      return update(state, {
        errorCode: {
          $set: 1,
        },
        errorMsg: {
          $set: action.errorMsg,
        },
        isFetching: {
          $set: false,
        },
      });
    }
    default:
      return state;
  }
};

export default reducer;
